import { countryList } from "@/services/api/Master";
import { useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { ScrollArea } from "./ui/scroll-area";

function SelectCountry({
  isModal = true,
  value,
  onChange,
  disabled = false,
  className = "",
  label = "",
  asValue = "",
} = {}) {
  const [countries, setCountries] = useState([]);

  const setCountry = async () => {
    if (countries.length === 0) {
      try {
        const list = await countryList();
        setCountries(list);
      } catch (error) {
        console.log("Error", error);
      }
    }
  };

  useEffect(() => {
    setCountry();
  }, []);

  return (
    <Select disabled={disabled} value={value} onValueChange={onChange}>
      <SelectTrigger
        className={
          isModal
            ? "bg-white text-background border-background/20 focus:ring-0"
            : "bg-white/5 hover:bg-white/10"
        }
      >
        <SelectValue placeholder='-- Select --' />
      </SelectTrigger>
      <SelectContent>
        <ScrollArea className='h-64'>
          {countries.map((country) => (
            <SelectItem
              key={`select-country-${country.code}`}
              value={asValue ? country[asValue] : country.name}
            >
              {country.name}
            </SelectItem>
          ))}
        </ScrollArea>
      </SelectContent>
    </Select>
  );
}

export default SelectCountry;
